import { render, staticRenderFns } from "./StopStatusButton.vue?vue&type=template&id=0ec60a16&scoped=true&"
import script from "./StopStatusButton.vue?vue&type=script&lang=js&"
export * from "./StopStatusButton.vue?vue&type=script&lang=js&"
import style0 from "./StopStatusButton.vue?vue&type=style&index=0&id=0ec60a16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec60a16",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ec60a16')) {
      api.createRecord('0ec60a16', component.options)
    } else {
      api.reload('0ec60a16', component.options)
    }
    module.hot.accept("./StopStatusButton.vue?vue&type=template&id=0ec60a16&scoped=true&", function () {
      api.rerender('0ec60a16', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Stops/buttons/StopStatusButton.vue"
export default component.exports